import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";

import { UserSession, useSession } from "0.Mine/2.Context/sessionContext";
import axiosInstance from "0.Mine/axiosInstance";

export const useSignUpWithCredentials = () => {
  const { updateSession } = useSession();
  const [error, setError] = useState<string>();
  const { enqueueSnackbar } = useSnackbar();
  const signupWithCredentials = async (
    username: string,
    email: string,
    password: string,
    confirmPassword: string
  ) => {
    if (password !== confirmPassword) {
      setError("Passwords do not match");
      enqueueSnackbar("Passwords do not match", {
        variant: "error",
        anchorOrigin: { vertical: "top", horizontal: "center" },
      });
      return;
    }

    enqueueSnackbar("Creating your account...", {
      variant: "info",
      key: "signup-process",
    });

    try {
      const response = await axiosInstance.post(`auth/signin.php`, { username, email, password });
      console.log(response);
      const data = response.data;

      const userSession: UserSession = {
        user: {
          id: response.data.user.id,
          name: response.data.user.name,
          email: response.data.user.email,
          image: response.data.user.profile_pic,
          token: response.data.user.token,
          subscriptionExpiry: response.data.user.subscription_expiry,
          subscriptionTier: response.data.user.subcription_tier,
          tokenExpiry: response.data.user.token_expiry,
          trialExpiry: response.data.user.trial_expiry,
          onboarding: response.data.user.onboarding,
          qlickup: response.data.user.qlickup,
          businessid: response.data.user.businessid,
          permissions: response.data.user.permissions,
        },
      };

      enqueueSnackbar(`Welcome to QlickUp, ${userSession.user.name}!`, {
        variant: "success",
        autoHideDuration: 8000,
      });

      updateSession(userSession);
    } catch (error) {
      console.log(error);
      const errorMessage = error.response?.data?.error || "Error creating your account";
      setError(errorMessage);

      // Error notification
      enqueueSnackbar(errorMessage, {
        variant: "error",
        preventDuplicate: true,
      });

      return;
    }
  };

  return { signupWithCredentials, error };
};
